<template>
  <div>
    <!-- Reports Modal -->
    <b-modal id="reportsBIASEDModal" size="xl" content-class="menu-bg-blue-transparent-modal biased-reports-modal" body-class="scroll-Container"
      title="BIASED ANSI Summary and Reports" hide-footer scrollable @show="getANSIReport()"
      @shown="createMap()">
      <!-- Selset selector -->
      <b-row class="mx-5">
        <b-col class="col-sm-4 py-2">
          <b-form-select v-model="selectedLayer" class="scroll-Container mb-4" @change="refreshModal($event, 'type')"
            style="margin-bottom: 5px;">
            <template #first>
              <b-form-select-option :value="null" disabled>
                Select Type
              </b-form-select-option>
            </template>
            <b-form-select-option v-for="(type, index) in types" :key="index" :value="type.value">
              {{ type.label }}
            </b-form-select-option>
          </b-form-select>
          <b-form-select v-model="selected" class="scroll-Container" @change="refreshModal($event, 'selset')">
            <template #first>
              <b-form-select-option :value="null" disabled>
                Select Selset
              </b-form-select-option>
            </template>
            <b-form-select-option v-for="(set, index) in selset" :key="index" :value="set.selset">
              {{ set.selset }}
            </b-form-select-option>
          </b-form-select>
        </b-col>
        <b-col class="col-sm-8 py-2">
          <b-row class="py-1 ml-5">
            <b-col>
              <div class="rpt-stat">
                <span class="rpt-stat-label">Total Segments</span>
                <span class="rpt-stat-value">{{ total }}</span>
              </div>
            </b-col>
            <b-col>
              <div class="rpt-stat">
                <span class="rpt-stat-label">Part Number</span>
                <span class="rpt-stat-value">{{ partNumber }}</span>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <div>
        <b-tabs align="center" pills card>
          <b-tab title="Summary" active>
            <b-row class="col-md-12 pb-5">
              <b-col>
                <apexchart type="donut" width="700" :options="chartOptions" :series="series">
                </apexchart>
                <b-row> </b-row>
              </b-col>
              <b-col>
                <div>
                  <div id="mapANSI" class="ol-map mapANSI"></div>
                </div>
              </b-col>
            </b-row>
            <div class="text-center">
              <b-button type="button" variant="primary" class="mx-2 rpt-dl-btn" @click="createReport()">
                CSV Download
              </b-button>
              <b-button type="button" variant="primary" class="mx-2 rpt-dl-btn" @click="createShapefileLink()">
                Shapefile Download
              </b-button>
            </div>
          </b-tab>
          <b-tab title="Details">
            <vue-bootstrap4-table :rows="reportRows" :columns="reportColumns" :config="config" :classes="classes">
            </vue-bootstrap4-table>
          </b-tab>
          <b-tab title="Issues">
            <vue-bootstrap4-table :rows="issuesRows" :columns="issuesColumns" :config="config" :classes="classes">
            </vue-bootstrap4-table>
          </b-tab>
          <b-tab title="Subcountries">
            <vue-bootstrap4-table :rows="subcountryRows" :columns="subcountryColumns" :config="config"
              :classes="classes">
            </vue-bootstrap4-table>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>
  </div>
</template>
<style scoped>
.mapANSI {
  height: clamp(300px, 55vh, 600px) !important;
  width: min(43.75rem, 100%);
}
</style>

<style>
/* ── Modal header (dark blue strip at top) ─────────────── */
.biased-reports-modal .modal-header {
  background: #063c6d;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  padding: 12px 20px;
  border-radius: 7px 7px 0 0;
}

.biased-reports-modal .modal-title {
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #fff;
  text-shadow: none;
}

/* ── Scrollbar ─────────────────────────────────────────── */
.biased-reports-modal .scroll-Container {
  scrollbar-width: thin;
  scrollbar-color: rgba(6, 60, 109, 0.25) transparent;
}
.biased-reports-modal .scroll-Container::-webkit-scrollbar { width: 4px; }
.biased-reports-modal .scroll-Container::-webkit-scrollbar-track { background: transparent; }
.biased-reports-modal .scroll-Container::-webkit-scrollbar-thumb { background: rgba(6, 60, 109, 0.25); border-radius: 2px; }
.biased-reports-modal .scroll-Container::-webkit-scrollbar-button { display: none; }

/* ── Metadata stat cards ───────────────────────────────── */
.rpt-stat {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  padding: 10px 12px;
  background: rgba(6, 60, 109, 0.06);
  border: 1px solid rgba(6, 60, 109, 0.15);
  border-radius: 6px;
  margin-bottom: 4px;
}
.rpt-stat-label {
  font-size: 0.6rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(6, 60, 109, 0.55);
}
.rpt-stat-value {
  font-size: 0.95rem;
  font-weight: 700;
  color: #063c6d;
  line-height: 1.2;
}

/* ── Selset dropdown / form controls ──────────────────── */
.biased-reports-modal label {
  color: rgba(6, 60, 109, 0.65);
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.biased-reports-modal select,
.biased-reports-modal .scroll-Container.custom-select {
  background: #fff !important;
  border: 1px solid rgba(6, 60, 109, 0.25) !important;
  color: #063c6d !important;
  border-radius: 4px;
}
.biased-reports-modal select option {
  background: #fff;
  color: #063c6d;
}
.biased-reports-modal input[type="text"],
.biased-reports-modal input[type="search"] {
  background: #fff !important;
  border: 1px solid rgba(6, 60, 109, 0.25) !important;
  color: #063c6d !important;
  border-radius: 4px;
}
.biased-reports-modal input::placeholder {
  color: rgba(6, 60, 109, 0.35) !important;
}

/* ── b-tabs pill nav ───────────────────────────────────── */
.biased-reports-modal .nav-pills .nav-link {
  color: rgba(6, 60, 109, 0.7);
  background: transparent;
  border: 1px solid rgba(6, 60, 109, 0.2);
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  padding: 4px 14px;
  margin: 0 3px;
}
.biased-reports-modal .nav-pills .nav-link.active,
.biased-reports-modal .nav-pills .show > .nav-link {
  background: #063c6d !important;
  border-color: #063c6d !important;
  color: #fff !important;
}
.biased-reports-modal .nav-pills .nav-link:hover {
  background: rgba(6, 60, 109, 0.08);
  color: #063c6d;
}
.biased-reports-modal .card {
  background: transparent !important;
  border: none !important;
}
.biased-reports-modal .tab-content {
  background: transparent !important;
  color: #063c6d;
}
.biased-reports-modal .card-body {
  background: transparent !important;
  padding: 16px 0;
}

/* ── Download buttons ──────────────────────────────────── */
.biased-reports-modal .rpt-dl-btn,
.biased-reports-modal .btn-primary {
  background: #063c6d !important;
  border-color: #063c6d !important;
  color: #fff !important;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 6px 18px;
  border-radius: 4px;
}
.biased-reports-modal .rpt-dl-btn:hover,
.biased-reports-modal .btn-primary:hover {
  background: #0a5499 !important;
  border-color: #0a5499 !important;
}
.biased-reports-modal .btn-secondary {
  background: transparent !important;
  border-color: rgba(6, 60, 109, 0.3) !important;
  color: rgba(6, 60, 109, 0.65) !important;
}
.biased-reports-modal .btn-secondary:hover {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
}

/* ── Table ─────────────────────────────────────────────── */
.biased-reports-modal table {
  background: transparent !important;
  color: #063c6d !important;
  text-shadow: none !important;
}
.biased-reports-modal thead th {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.12) !important;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  text-shadow: none !important;
}
.biased-reports-modal thead th a,
.biased-reports-modal thead th svg {
  color: rgba(6, 60, 109, 0.5) !important;
}
.biased-reports-modal tbody tr {
  cursor: pointer;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.08) !important;
  text-shadow: none !important;
}
.biased-reports-modal tbody tr:hover {
  background: rgba(6, 60, 109, 0.04) !important;
}
.biased-reports-modal tbody td {
  border-color: rgba(6, 60, 109, 0.08) !important;
  color: #063c6d !important;
  font-size: 0.75rem;
  text-shadow: none !important;
}

/* ── ApexCharts ────────────────────────────────────────── */
.biased-reports-modal .apexcharts-canvas {
  background: transparent !important;
}
.biased-reports-modal .apexcharts-legend-text {
  color: rgba(6, 60, 109, 0.85) !important;
}
</style>
<script>
import axios from 'axios'
import GeoJSON from 'ol/format/GeoJSON'
import VectorSource from 'ol/source/Vector'
import VueBootstrap4Table from 'vue-bootstrap4-table'
import { get as projGet, transformExtent } from 'ol/proj'
import Map from 'ol/Map'
import OSM from 'ol/source/OSM'
import TileLayer from 'ol/layer/Tile'
import { createLayers } from '../../../utils/utils.js'
import View from 'ol/View'
import * as XLSX from 'xlsx'
export default {
  name: 'MMP_Biased_Reports',
  props: [
    'ansiLayerName',
    'ansiSelectedSelset',
    'apiUrl',
    'currentANSIPartNumber',
    'layerDefinition',
    'mmp_layersObj',
    'extent',
    'customerProjectId'
  ],
  components: {
    VueBootstrap4Table
  },
  data() {
    return {
      types: [
        { value: 'lane_type_added_subaru', label: 'Added' },
        { value: 'lane_type_diverging_subaru', label: 'Diverging' },
        { value: 'lane_type_end_subaru', label: 'End of Map' },
        { value: 'lane_type_ending_subaru', label: 'Ending' },
        { value: 'lane_type_merging_subaru', label: 'Merging' },
        { value: 'lane_type_start_subaru', label: 'Start of Map' }
      ],
      mapANSI: null,
      chart: null,
      total: null,
      layerType: null,
      url: null,
      series: [],
      chartOptions: {
        chart: {
          id: 'ANSIReport',
          width: 360,
          type: 'donut'
        },
        labels: [],
        legend: {
          labels: {
            useSeriesColors: true
          }
        },
        plotOptions: {},
        dataLabels: {
          enabled: true
        }
      },
      selset: null,
      selected: null,
      selectedLayer: null,
      partNumber: null,
      reportRows: [],
      classes: {
        table: {
          'menu-bg-blue-transparent-modal': true
        }
      },
      reportColumns: [
        {
          label: 'Segment Id',
          name: 'road_segment_id',
          sort: true
        },
        {
          label: 'Technician',
          name: 'technician',
          sort: true
        },
        {
          label: 'Review Date',
          name: 'review_date',
          sort: true
        }
      ],
      config: {
        checkbox_rows: false,
        rows_selectable: true,
        card_mode: false,
        global_search: {
          placeholder: 'Search...',
          visibility: true,
          showClearButton: true,
          searchOnPressEnter: true
        },
        highlight_row_hover_color: '#4a4a4a',
        per_page: 15,
        show_refresh_button: false,
        show_reset_button: false
      },
      issuesRows: [],
      issuesColumns: [
        {
          label: 'Segment Id',
          name: 'id',
          sort: true
        },
        {
          label: 'Subcountry',
          name: 'state_name',
          sort: true
        },
        {
          label: 'Technician',
          name: 'technician',
          sort: true
        },
        {
          label: 'Notes',
          name: 'notes',
          sort: true
        },
        {
          label: 'Review Date',
          name: 'last_updated',
          sort: true
        }
      ],
      subcountryRows: [],
      subcountryColumns: [
        {
          label: 'Subcountry',
          name: 'subcountry',
          sort: true
        },
        {
          label: 'Count',
          name: 'count',
          sort: true
        }
      ],
      totalReviewTime: null,
      createdDate: null,
      ansiData: [],
      dropdownSelsetValue: null,
      originalLayerSource: null,
      geoserverDetails: [
        {
          workspace: 'nissan',
          layers: {
            'lane_type_start_nissan': 'nissan:biased_start',
            'lane_type_end_nissan': 'nissan:biased_end'
          },
          name: 'ansi_nissan'
        },
        {
          workspace: 'rivian_charlie_workspace',
          layers: {
            'lane_type_start_rivian': 'rivian_charlie:biased_start',
            'lane_type_end_rivian': 'rivian_charlie:biased_end'
          },
          name: 'ansi_rivian_udbx2'
        },
        {
          workspace: 'subaru',
          layers: {
            'lane_type_added_subaru': 'subaru:biased_added',
            'lane_type_diverging_subaru': 'subaru:biased_diverging',
            'lane_type_end_subaru': 'subaru:biased_end',
            'lane_type_ending_subaru': 'subaru:biased_ending',
            'lane_type_merging_subaru': 'subaru:biased_merging',
            'lane_type_start_subaru': 'subaru:biased_start'
          },
          name: 'ansi_subaru'
        },
        {
          workspace: 'gm',
          layers: {
             'lane_type_start_gm': 'gm:biased_start',
            'lane_type_end_gm': 'gm:biased_end'
          },
          name: 'ansi_gm'
        },
      ],
      layerExtent: []
    }
  },
  methods: {
    refreshModal(value, option) {
      if (option == 'type') {
        this.selectedLayer = value
      } else if (option == 'selset') {
        this.selected = String(value)
      }
      this.getReport()
      this.getAnsiTableDetails()
      this.createMap(this.selected)
    },
    getReport() {
      this.getSelset()
      this.dropdownSelsetValue = this.selected
      if (sessionStorage.token) {
        axios
          .get(
            process.env.API_LOCATION + `/api/${this.apiUrl}/biased_report/`,
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'x-auth-token': sessionStorage.token
              },
              params: {
                type: this.selectedLayer,
                part_number: this.currentANSIPartNumber.part_number
              }
            }
          )
          .then(response => {
            const content = response.data
            this.renderChart(content)
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token.')
      }
    },
    createReport() {
      /* This method is required because you can't pass
      the 'this' variable in the Vue @click event */
      this.createCSV(this)
    },
    createCSV: async self => {
      await Promise.all([
        self.getAnsiDetailedReport(self),
        self.getAnsiIssues(self),
        self.getAnsiSubcountries(self),
        self.getAnsiData(self)
      ]).then(values => {
        // The values array holds data in the same order as the above Promises
        try {
          let reportRows = XLSX.utils.json_to_sheet(values[0])
          let subcountryRows = XLSX.utils.json_to_sheet(values[2])
          let issuesRows = XLSX.utils.json_to_sheet(values[1])
          let ansiData = XLSX.utils.json_to_sheet(values[3])
          if (values[3].length > 0 && ansiData) {
            let wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, reportRows, 'Summary')
            XLSX.utils.book_append_sheet(wb, subcountryRows, 'Subcountries')
            XLSX.utils.book_append_sheet(wb, issuesRows, 'Issues')
            XLSX.utils.book_append_sheet(wb, ansiData, 'Details')
            XLSX.writeFile(wb, `${self.dropdownSelsetValue}_ANSI_Report.xlsx`)
          } else {
            let errMsg = 'No Data Available.'
            self.$bvToast.toast(errMsg, {
              autoHideDelay: 10000,
              title: 'Error Downloading CSV',
              toaster: 'b-toaster-top-center'
            })
          }
        } catch (error) {
          console.log(error)
        }
      })
    },
    createShapefileLink() {
      let layerName = this.types.filter(type => type.value == this.selectedLayer)[0].label
      let layerSource = this.mmp_layersObj[layerName].layer.getSource()
      this.url = layerSource.getUrls()[0].split('wms')[0]
      this.layerType = layerSource.params_.LAYERS
      this.url += `ows?service=WFS&version=1.0.0&request=GetFeature&authkey=${sessionStorage.token}&typeName=${this.layerType}&outputFormat=SHAPE-ZIP&CQL_FILTER=part_number='${this.currentANSIPartNumber.part_number}'`
      window.open(this.url)
    },
    getSelset() {
      if (sessionStorage.token) {
        axios
          .get(
            process.env.API_LOCATION + '/api/' + this.apiUrl + '/getBiasedSelsets',
            {
              method: 'GET',
              headers: {
                'x-auth-token': sessionStorage.token
              }
            }
          )
          .then(response => {
            const content = response.data
            if (!content.errors) {
              this.selset = content.rows
            } else {
              console.log('getAllSelsets API Call Error: ' + content.errors)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token.')
      }
    },
    renderChart(content) {
      // Sort response data into appropriate axis for graphing
      let chartOptions = []
      let series = []
      let sum = 0
      let caseType = null // Added new variable for displaying sum
      content.forEach(element => {
        if (element.overall == '') {
          caseType = 'not_reviewed'
        } else {
          caseType = element.overall
        }
        chartOptions.push(caseType)
        series.push(parseFloat(element.count))
        sum += parseFloat(element.count)
      })
      // Assign sorted data to graph
      ApexCharts.exec('ANSIReport', 'updateOptions', { labels: chartOptions })
      ApexCharts.exec('ANSIReport', 'updateSeries', series)
      this.total = sum
    },
    getANSIReport() {
      this.dropdownSelsetValue = this.ansiSelectedSelset
      this.selected = this.ansiSelectedSelset
      this.getReport()
      this.getAnsiTableDetails()
    },
    getAnsiDetailedReport: async self => {
      if (sessionStorage.token) {
        const rows = await axios
          .get(
            `${process.env.API_LOCATION}/api/${self.apiUrl}/getBiasedTimeLine`,
            {
              method: 'GET',
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: {
                selset: self.dropdownSelsetValue,
                table: self.selectedLayer,
                partNumber: self.currentANSIPartNumber.part_number
              }
            }
          )
          .then(response => {
            const content = response.data
            if (!content.errors) {
              self.reportRows = content.rows
            } else {
              console.log('getBiasedTimeLine API Call Error: ' + content.errors)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
        return self.reportRows
      } else {
        console.log('No User Token.')
      }
    },
    getAnsiIssues: async self => {
      if (sessionStorage.token) {
        const rows = await axios
          .get(`${process.env.API_LOCATION}/api/${self.apiUrl}/getBiasedIssues`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'x-auth-token': sessionStorage.token
            },
            params: {
              selset: self.selected,
              table: self.selectedLayer,
              partNumber: self.currentANSIPartNumber.part_number
            }
          })
          .then(response => {
            self.issuesRows = response.data.rows
          })
          .catch(function (error) {
            console.log(error)
          })
        return self.issuesRows
      } else {
        console.log('No User Token.')
      }
    },
    getAnsiSubcountries: async self => {
      if (sessionStorage.token) {
        const rows = await axios
          .get(
            `${process.env.API_LOCATION}/api/${self.apiUrl}/getBiasedSubcountries`,
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'x-auth-token': sessionStorage.token
              },
              params: {
                selset: self.selected,
                table: self.selectedLayer,
                partNumber: self.currentANSIPartNumber.part_number
              }
            }
          )
          .then(response => {
            self.subcountryRows = response.data.rows
          })
          .catch(function (error) {
            console.log(error)
          })
        return self.subcountryRows
      } else {
        console.log('No User Token.')
      }
    },
    getAnsiTableDetails() {
      if (sessionStorage.token) {
        axios
          .get(
            process.env.API_LOCATION +
            '/api/' +
            this.apiUrl +
            '/getBiasedTableDetails',
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'x-auth-token': sessionStorage.token
              },
              params: {
                selset: this.dropdownSelsetValue,
                table: this.selectedLayer,
                partNumber: this.currentANSIPartNumber.part_number
              }
            }
          )
          .then(response => {
            let content = response.data.rows[0]
            this.partNumber = content.partnumber
            this.getAnsiDetailedReport(this)
            this.getAnsiIssues(this)
            this.getAnsiSubcountries(this)
            this.getAnsiData(this)
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token.')
      }
    },
    getAnsiData: async self => {
      if (sessionStorage.token) {
        const rows = await axios
          .get(`${process.env.API_LOCATION}/api/${self.apiUrl}/getBiasedData`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'x-auth-token': sessionStorage.token
            },
            params: {
              selset: self.selected,
              extent: self.extent,
              table: self.selectedLayer,
              partNumber: self.currentANSIPartNumber.part_number
            }
          })
          .then(response => {
            self.ansiData = response.data.rows
          })
          .catch(function (error) {
            console.log(error)
          })
        return self.ansiData
      } else {
        console.log('No User Token.')
      }
    },
    zoomToFitFeatures(layer, selectedSelset) {
      let layerSource = layer.getSource()
      if (selectedSelset) {
        layerSource.updateParams({
          CQL_FILTER: `part_number='${this.currentANSIPartNumber.part_number}'`
        })
      }
      let layerParams = layerSource.getParams()
      let baseUrl = layerSource.getUrl().split('service=')[0]
      let layerType = this.geoserverDetails.filter(
        e => e.name == this.apiUrl
      )[0].layers[this.selectedLayer]
      // let url =
      //   baseUrl +
      //   'service=WFS&request=GetFeature&typeName=' +
      //   layerType + 
      //   '&outputFormat=application/json&format_options=callback:getJsonFeatureExtent&authkey=' + sessionStorage.token + '&CQL_FILTER=' +
      //   encodeURI(layerParams.CQL_FILTER)
      const url = `${baseUrl}?service=WFS&request=GetFeature&typeName=${layerType}&outputFormat=application/json&format_options=callback:getJsonFeatureExtent&authkey=${sessionStorage.token}&CQL_FILTER=${encodeURIComponent(layerParams.CQL_FILTER)}`;
      axios
        .get(url, {})
        .then(response => {
          let features = new GeoJSON().readFeatures(response.data)
          if (features.length != 0) {
            let fittedExtent = new transformExtent(
              new VectorSource({ features: features }).getExtent(),
              new projGet('EPSG:4326'),
              new projGet('EPSG:3857')
            )
            let fittedPadding = 20
            let fittedOptions = {
              padding: [
                fittedPadding,
                fittedPadding,
                fittedPadding,
                fittedPadding
              ]
            }
            this.mapANSI.getView().fit(fittedExtent, fittedOptions)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    createMap(selectedSelset) {
      if (sessionStorage.token) {
        axios
          .get(
            process.env.API_LOCATION +
            '/api/' +
            this.apiUrl +
            '/calculateBiasedExtent',
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'x-auth-token': sessionStorage.token
              },
              params: {
                selset: this.selected,
                table: this.selectedLayer,
                partNumber: this.currentANSIPartNumber.part_number
              }
            }
          )
          .then(response => {
            this.layerExtent = response.data.rows[0]
            if (selectedSelset != undefined) {
              if (this.mapANSI.getLayers().array_.filter(arr => { arr.get('name').includes(this.selectedLayer) }).length) {
                this.mapANSI.getLayers().forEach(layer => {
                  if (!layer.get('name').includes('OSM') && layer.get('name').includes(this.selectedLayer)) {
                    layer.setOpacity(1) // turn on the current layer
                    this.zoomToFitFeatures(layer, selectedSelset)
                  }
                })
              } else {
                // Remove old layers
                this.mapANSI.getLayers().forEach(layer => {
                  if (!layer.get('name').includes('OSM')) {
                    // this.mapANSI.removeLayer(layer)
                    layer.setOpacity(0)
                  }
                })
                let view = new View({
                  center: [this.layerExtent.x, this.layerExtent.y],
                  zoom: 2,
                  minZoom: 2,
                  multiWorld: true,
                  constrainOnlyCenter: true
                })
                this.mapANSI.setView(view)
                let urlInfo = this.geoserverDetails.filter(
                  e => e.name == this.apiUrl
                )[0]
                let layerInfo = [
                  {
                    display_name: 'ANSI',
                    layerType: 'ImageWMS',
                    name: `ANSI Report (${this.selectedLayer})`,
                    params: {
                      CQL_FILTER: `part_number='${this.currentANSIPartNumber.part_number}'`,
                      LAYERS: urlInfo.layers[this.selectedLayer],
                      FORMAT: 'image/png',
                      authkey: sessionStorage.token
                    },
                    url: `https://geoserver-aws.ushrauto.com/geoserver/${urlInfo.workspace}/wms`,
                    zIndex: 500000,
                    zoomControl: false
                  }
                ]
                createLayers(layerInfo, this.mapANSI)
                this.mapANSI.getLayers().forEach(layer => {
                  if (!layer.get('name').includes('OSM')) {
                    this.zoomToFitFeatures(layer, this.selected)
                  }
                })
              }
            } else {
              this.mapANSI = new Map({
                layers: [
                  new TileLayer({
                    source: new OSM(),
                    name: 'OSM base layer',
                    zIndex: 2
                  })
                ],
                target: 'mapANSI',
                view: new View({
                  center: [this.layerExtent.x, this.layerExtent.y],
                  zoom: 2,
                  minZoom: 2,
                  multiWorld: true,
                  constrainOnlyCenter: true
                })
              })
              let urlInfo = this.geoserverDetails.filter(
                e => e.name == this.apiUrl
              )[0]
              let layerInfo = [
                  {
                    display_name: 'ANSI',
                    layerType: 'ImageWMS',
                    name: `ANSI Report (${this.selectedLayer})`,
                    params: {
                      CQL_FILTER: `part_number='${this.currentANSIPartNumber.part_number}'`,
                      LAYERS: urlInfo.layers[this.selectedLayer],
                      FORMAT: 'image/png',
                      authkey: sessionStorage.token
                    },
                    url: `https://geoserver-aws.ushrauto.com/geoserver/${urlInfo.workspace}/wms`,
                    zIndex: 500000,
                    zoomControl: false
                  }
                ]
              createLayers(layerInfo, this.mapANSI)
              this.mapANSI.getLayers().forEach(layer => {
                if (!layer.get('name').includes('OSM')) {
                  this.zoomToFitFeatures(layer, this.selected)
                }
              })
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token.')
      }
    },
    setBiasedOptions(projectId) {
      switch(projectId) {
        case '5':
           // customerProjectId = 5 -- Nissan ANSI
          this.types = [
            { value: 'lane_type_start_nissan', label: 'Start of Map' },
            { value: 'lane_type_end_nissan', label: 'End of Map' },
          ]
          this.selectedLayer = this.types[0].value
          break;
        case '29':
           // customerProjectId = 29 -- Rivian ANSI
          this.types = [
            { value: 'lane_type_start_rivian', label: 'Start of Map' },
            { value: 'lane_type_end_rivian', label: 'End of Map' },
          ]
          this.selectedLayer = this.types[0].value
          break;
        case '22':
          // customerProjectId = 22 -- GM ANSI
          this.types = [
            { value: 'lane_type_start_gm', label: 'Start of Map' },
            { value: 'lane_type_end_gm', label: 'End of Map' },
          ]
          this.selectedLayer = this.types[0].value
          break;
        case '23':
          // customerProjectId = 23 -- Subaru ANSI
          this.types = [
            { value: 'lane_type_added_subaru', label: 'Added' },
            { value: 'lane_type_diverging_subaru', label: 'Diverging' },
            { value: 'lane_type_end_subaru', label: 'End of Map' },
            { value: 'lane_type_ending_subaru', label: 'Ending' },
            { value: 'lane_type_merging_subaru', label: 'Merging' },
            { value: 'lane_type_start_subaru', label: 'Start of Map' }
          ]
          this.selectedLayer = this.types[0].value
          break;
      }
    }
  },
  mounted() {
    this.setBiasedOptions(this.customerProjectId)
  },
  watch: {
    layerDefinition: function (newValue, oldValue) {
      this.layerDefinition = newValue
    },
    customerProjectId: function(newValue) {
      this.setBiasedOptions(newValue)
    }
  }
}
</script>